<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M15.3281 0H2.67188C1.79954 0 1.08984 0.709699 1.08984 1.58203V16.418C1.08984 17.2903 1.79954 18 2.67188 18H15.3281C16.2005 18 16.9102 17.2903 16.9102 16.418V1.58203C16.9102 0.709699 16.2005 0 15.3281 0ZM15.8555 16.418C15.8555 16.7087 15.6189 16.9453 15.3281 16.9453H2.67188C2.3811 16.9453 2.14453 16.7087 2.14453 16.418V1.58203C2.14453 1.29125 2.3811 1.05469 2.67188 1.05469H15.3281C15.6189 1.05469 15.8555 1.29125 15.8555 1.58203V16.418Z"
        class="icon-fill"/>
    <path
        d="M14.2734 2.10938H3.72656C3.43533 2.10938 3.19922 2.34548 3.19922 2.63672V6.92578C3.19922 7.21702 3.43533 7.45312 3.72656 7.45312H14.2734C14.5647 7.45312 14.8008 7.21702 14.8008 6.92578V2.63672C14.8008 2.34548 14.5647 2.10938 14.2734 2.10938ZM13.7461 6.39844H4.25391V3.16406H13.7461V6.39844Z"
        class="icon-fill"/>
    <path
        d="M5.83594 8.50781H3.72656C3.43533 8.50781 3.19922 8.74392 3.19922 9.03516V11.1445C3.19922 11.4358 3.43533 11.6719 3.72656 11.6719H5.83594C6.12717 11.6719 6.36328 11.4358 6.36328 11.1445V9.03516C6.36328 8.74392 6.12717 8.50781 5.83594 8.50781ZM5.30859 10.6172H4.25391V9.5625H5.30859V10.6172Z"
        class="icon-fill"/>
    <path
        d="M5.83594 12.7266H3.72656C3.43533 12.7266 3.19922 12.9627 3.19922 13.2539V15.3633C3.19922 15.6545 3.43533 15.8906 3.72656 15.8906H5.83594C6.12717 15.8906 6.36328 15.6545 6.36328 15.3633V13.2539C6.36328 12.9627 6.12717 12.7266 5.83594 12.7266ZM5.30859 14.8359H4.25391V13.7812H5.30859V14.8359Z"
        class="icon-fill"/>
    <path
        d="M10.0547 8.50781H7.94531C7.65408 8.50781 7.41797 8.74392 7.41797 9.03516V11.1445C7.41797 11.4358 7.65408 11.6719 7.94531 11.6719H10.0547C10.3459 11.6719 10.582 11.4358 10.582 11.1445V9.03516C10.582 8.74392 10.3459 8.50781 10.0547 8.50781ZM9.52734 10.6172H8.47266V9.5625H9.52734V10.6172Z"
        class="icon-fill"/>
    <path
        d="M10.0547 12.7266H7.94531C7.65408 12.7266 7.41797 12.9627 7.41797 13.2539V15.3633C7.41797 15.6545 7.65408 15.8906 7.94531 15.8906H10.0547C10.3459 15.8906 10.582 15.6545 10.582 15.3633V13.2539C10.582 12.9627 10.3459 12.7266 10.0547 12.7266ZM9.52734 14.8359H8.47266V13.7812H9.52734V14.8359Z"
        class="icon-fill"/>
    <path
        d="M14.2734 8.50781H12.1641C11.8728 8.50781 11.6367 8.74392 11.6367 9.03516V15.3633C11.6367 15.6545 11.8728 15.8906 12.1641 15.8906H14.2734C14.5647 15.8906 14.8008 15.6545 14.8008 15.3633V9.03516C14.8008 8.74392 14.5647 8.50781 14.2734 8.50781ZM13.7461 14.8359H12.6914V9.5625H13.7461V14.8359Z"
        class="icon-fill"/>
  </svg>

</template>

<script>
export default {
  name: 'calculator'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>